module.exports = {"230223100":"依安镇","230223101":"依龙镇","230223102":"双阳镇","230223103":"三兴镇","230223104":"中心镇","230223105":"新兴镇","230223200":"富饶乡","230223201":"解放乡","230223202":"阳春乡","230223203":"新发乡","230223204":"太东乡","230223205":"上游乡","230223206":"红星乡","230223207":"先锋乡","230223208":"新屯乡","230223500":"依安农场","230223501":"红旗种马场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230223.json
// module id = 698
// module chunks = 0